/* -------------------------------------------------------------------------
 * Sayuri signature · hot-spring-steam  (Kusatsu Yubatake)
 * -------------------------------------------------------------------------
 * Port of `HotSpringSteam` in the design file (line ~1122). Like tea-steam
 * but bigger, warmer, and heavier — the huge slow rolls of mineral steam
 * coming off an onsen. Combines white highlights with scent accent tint.
 *
 * Scent character: "Hot water on stone, cypress steam, the smell of
 * warmth itself." Wet + warm + enveloping.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('hot-spring-steam', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 16 : 10;
      var accentSoft = ctx.accentSoft;
      var rand = ctx.seed('hot-spring-steam'.charCodeAt(0) * 131 + 16 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var w = 300 + rand() * 350;       // 300–650px wide
        var dur = 24 + rand() * 16;       // 24–40s
        var delay = -rand() * 25;
        var variant = i % 3;

        var p = document.createElement('div');
        p.className = 'sayuri-hot-steam';
        p.style.position = 'absolute';
        p.style.left = left + 'vw';
        p.style.bottom = '-150px';
        p.style.width = w + 'px';
        p.style.height = (w * 1.6) + 'px';
        p.style.background =
          'radial-gradient(ellipse 50% 60% at 50% 70%, #ffffff66, ' +
          accentSoft + '33 50%, transparent 75%)';
        p.style.filter = 'blur(35px)';
        p.style.animation = 'hs-rise-' + variant + ' ' + dur + 's ease-out ' + delay + 's infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes hs-rise-0 { 0%{opacity:0;transform:translate(0,0) scale(0.9);} 20%{opacity:0.85;} 100%{opacity:0;transform:translate(60px,-130vh) scale(2.3);} }',
      '@keyframes hs-rise-1 { 0%{opacity:0;transform:translate(0,0) scale(0.9);} 20%{opacity:0.8;} 100%{opacity:0;transform:translate(-80px,-130vh) scale(2.5);} }',
      '@keyframes hs-rise-2 { 0%{opacity:0;transform:translate(0,0) scale(0.9);} 20%{opacity:0.85;} 100%{opacity:0;transform:translate(30px,-130vh) scale(2.2);} }'
    ].join('')
  });
})();
